import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModuleWithProviders } from '@angular/compiler/src/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { GetNamePipe } from './extensions/text.pipe';
import {RemoveWhitespacePipe} from "./extensions/remove-whitespace.pipe";
@NgModule({
  declarations: [GetNamePipe, RemoveWhitespacePipe],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MDBBootstrapModulesPro,
  ],
  exports: [
    GetNamePipe,
    RemoveWhitespacePipe,
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MDBBootstrapModulesPro,
  ],
})
export class SharedCoreModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedCoreModule,
      providers: []
    };
  }
}
